import styled from 'styled-components'

export const WrapperListActions = styled.div`
  display: flex;
  justify-content: flex-end;
  column-gap: 10px;
`
